import React, { Component } from 'react';
import data from './inventory.json';
const ProductContext = React.createContext();

class ProductProvider extends Component {
  state = {
    products: [],
    cart: [],
    cartTotal: 0,
    corgiInCart: false,
    displayCart: false,
    confirmDisplayed: false
  };
  componentDidMount() {
    this.setProducts();
  }

  setProducts = () => {
    let products = [];
    data.products.forEach(item => {
      const singleItem = { ...item };
      products = [...products, singleItem];
    });
    this.setState(() => {
      return { products };
    }, this.checkCartItems);
  };

  getItem = id => {
    const product = this.state.products.find(item => item.id === id);
    return product;
  };

  addToCart = id => {
    let tempProducts = [...this.state.products];
    const index = tempProducts.indexOf(this.getItem(id));
    const product = tempProducts[index];
    product.inCart = true;
    product.count = 1;
    const price = product.price;
    product.total = price;
    const required = product.required;
    if (required === 'true') {
      this.setState({ corgiInCart: true });
    }

    this.setState(() => {
      return {
        products: [...tempProducts],
        cart: [...this.state.cart, product]
      };
    }, this.getTotal);
  };

  addCount = id => {
    let tempCart = [...this.state.cart];
    const selectedProduct = tempCart.find(item => {
      return item.id === id;
    });
    const index = tempCart.indexOf(selectedProduct);
    const product = tempCart[index];
    product.count = product.count + 1;
    product.total = product.count * product.price;
    this.setState(() => {
      return {
        cart: [...tempCart]
      };
    }, this.getTotal);
  };

  subCount = id => {
    let tempCart = [...this.state.cart];
    const selectedProduct = tempCart.find(item => {
      return item.id === id;
    });
    const index = tempCart.indexOf(selectedProduct);
    const product = tempCart[index];
    product.count = product.count - 1;
    if (product.count === 0) {
      this.removeItem(id);
    } else {
      product.total = product.count * product.price;
      this.setState(() => {
        return { cart: [...tempCart] };
      }, this.getTotal);
    }
  };

  getTotal = () => {
    let total = 0;
    this.state.cart.map(item => (total += item.total));
    this.setState(() => {
      return {
        cartTotal: total
      };
    });
  };

  removeItem = id => {
    let tempProducts = [...this.state.products];
    let tempCart = [...this.state.cart];

    const index = tempProducts.indexOf(this.getItem(id));
    let removedProduct = tempProducts[index];
    removedProduct.inCart = false;
    removedProduct.count = 0;
    removedProduct.total = 0;
    if (removedProduct.required === 'true') {
      this.setState({ corgiInCart: false });
    }

    tempCart = tempCart.filter(item => {
      return item.id !== id;
    });

    this.setState(() => {
      return {
        cart: [...tempCart],
        products: [...tempProducts]
      };
    }, this.getTotal);
  };
  clearCart = () => {
    this.setState(
      () => {
        return { cart: [] };
      },
      () => {
        this.setProducts();
        this.getTotal();
      }
    );
  };

  toggleCartOff = () => {
    this.setState({ displayCart: false });
  };

  toggleCartOn = () => {
    this.setState({ displayCart: true });
  };

  checkoutOn = () => {
    const uiWindow = document.getElementById('ui-window');
    const checkout = document.getElementById('checkout');

    uiWindow.style.display = 'none';
    checkout.style.display = 'block';
    this.setState({ displayCart: false });
  };

  checkoutOff = () => {
    const uiWindow = document.getElementById('ui-window');
    const checkout = document.getElementById('checkout');

    uiWindow.style.display = 'grid';
    checkout.style.display = 'none';

    this.clearCart();
    this.setState({ confirmDisplayed: false });
  };

  backToProducts = () => {
    const uiWindow = document.getElementById('ui-window');
    const checkout = document.getElementById('checkout');

    uiWindow.style.display = 'grid';
    checkout.style.display = 'none';
  };

  showConfirm = () => {
    this.setState({ confirmDisplayed: true });
  };

  render() {
    return (
      <ProductContext.Provider
        value={{
          ...this.state,
          addToCart: this.addToCart,
          addCount: this.addCount,
          subCount: this.subCount,
          removeItem: this.removeItem,
          clearCart: this.clearCart,
          checkoutOn: this.checkoutOn,
          checkoutOff: this.checkoutOff,
          toggleCartOn: this.toggleCartOn,
          toggleCartOff: this.toggleCartOff,
          showConfirm: this.showConfirm,
          backToProducts: this.backToProducts
        }}
      >
        {this.props.children}
      </ProductContext.Provider>
    );
  }
}

const ProductConsumer = ProductContext.Consumer;

export { ProductProvider, ProductConsumer };
